import React from "react";
import { NavLink } from "react-router-dom";
import { NavbarElementWrapper, NavText } from "./NavbarElement.styled";

interface NavbarElementProps {
  texto: string;
  link: string;
}

const NavbarElement = ({ texto, link }: NavbarElementProps) => {
  return (
    <NavbarElementWrapper>
      <NavLink
        to={link}
        className={({ isActive }) =>
          isActive ? "nav-link active" : "nav-link"
        }
      >
        <NavText>{texto}</NavText>
      </NavLink>
    </NavbarElementWrapper>
  );
};

export default NavbarElement;